<div class="d-flex justify-content-between align-items-center gap-3 my-4">
  <div class="d-flex flex-column align-items-start">
    <p class="fw-bold fs-6 mb-0">{{ 'contractRegeneration.uploadOwnContract.title' | translate }}</p>
    <p class="mb-0">{{ 'contractRegeneration.uploadOwnContract.hintMessage' | translate }}</p>
  </div>
  <base-switch
    [(ngModel)]="isContractUploadEnabled"
    (ngModelChange)="onEnableContractUploadChange($event)"
    [isDisabled]="isContractUploadTurnedOff"
    [tooltip]="isContractUploadTurnedOff ? (disabledSwitchTooltip | translate) : undefined"
  ></base-switch>
</div>

<ng-container *ngIf="isContractUploadEnabled">
  <div
    class="d-flex flex-column"
    *ngIf="!contractUploadForm.controls.file.value; else contractPreview"
  >
    <base-button
      color="primary"
      label="document.upload"
      icon="fa-solid fa-file-arrow-up"
      [iconSize]="buttonSizes.md"
      (btnClick)="openContractUploadModal()"
    ></base-button>
    <p class="upload-warning">
      {{ 'contractRegeneration.uploadOwnContract.warningMessage' | translate }}
    </p>
  </div>

  <ng-template #contractPreview>
    <base-document-info
      [documentControl]="contractUploadForm.controls.file"
      (viewDocumentClicked)="viewContract()"
      (deleteClicked)="deleteUploadedContract()"
      class="mb-5"
    ></base-document-info>
  </ng-template>
</ng-container>

<ng-template #contractUploadModal>
  <base-document-upload-modal
    [documentUploadForm]="contractUploadForm"
    [submitted]="isContractUploadFormSubmitted"
    [fixedCategory]="true"
    [hideExpirationDateSelection]="true"
    [hideNameInputField]="true"
    fileTypePlaceholder="document.dragDrop.fileTypePDF"
  ></base-document-upload-modal>
</ng-template>

<ng-template #contractViewerModal>
  <base-document-viewer
    [src]="activeDocument"
    [title]="activeDocument?.name"
    [fileName]="activeDocument?.name ?? ''"
    [fileType]="baseFileExtension.pdf"
    [modalRef]="contractViewerModalRef"
  ></base-document-viewer>
</ng-template>
